export default "__VITE_ASSET__BzPzBUuc__"